import { ReactComponent as CallUsIconAlt } from "@icons/phone-alternative.svg";
import classNames from "classnames";
import { removeSpaces } from "shared/core/utils/string";
import { t } from "i18next";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";

const CallUsBlock = ({ code, number }: { code?: string; number: string }) => {
  let iconColor = "text-brand";
  const { isMobileApp } = useMobilePlatform();

  switch (code) {
    case "UK":
      iconColor = "text-brand";
      break;
    case "ROI":
      iconColor = "text-m-green";
      break;
    case "AU":
      iconColor = "text-m-yellow";
      break;
    case "NZ":
      iconColor = "text-m-yellow";
      break;
    default:
      break;
  }

  return (
    <>
      <CallUsIconAlt className={`shrink-0 w-12 ${iconColor}`} />
      <h2 className="ml-5 text-start">
        {`${code ? `${code}: ` : ""}${t("support.callUs.title")}`}{" "}
        {
          <a
            className={classNames({ "pointer-events-none cursor-default": isMobileApp }, "md:hidden whitespace-nowrap")}
            href={`tel:${removeSpaces(number)}`}
          >
            {number}
          </a>
        }
        <span className="hidden whitespace-nowrap md:inline">{number}</span>
      </h2>
    </>
  );
};

export default CallUsBlock;
